module.exports = __webpack_public_path__ + "static/img/ALEX-HOLT.5f030fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ALEX-HOLT.jpg
// module id = vnfM
// module chunks = 0